module.exports = __webpack_public_path__ + "img/business_qr_code.b5a27fdb.jpg";